module.exports = __webpack_public_path__ + "img/namibia-logo-icon.ea02fd95.png";